import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import {inject, observer} from 'mobx-react';
import {computed} from 'mobx';
import {FormattedMessage, injectIntl} from 'react-intl';
import BaseButton from '../../components/button/BaseButton';
import './styles.scss';

@withRouter
@injectIntl
@inject('userStore')
@observer
class CookiesContainer extends Component {

    setCookies = () => {
        this.props.userStore.approveCookiesMessage();
    };

    @computed get isHide() {
        return /(policy|terms|discover)/.test(this.props.location.pathname) || this.props.userStore.cookiesApproved;
    }

    render() {
        if (this.props.userStore.cookiesApproved || this.isHide) return null;
        const {intl: {formatMessage: translate}} = this.props;

        return (
            <div className="cookies-container">
                <div className="container">
                    <div className="cookies-popup">
                        <p><FormattedMessage id="cookies.popup.description"/> <Link to="/policy"><FormattedMessage id="cookies.popup.policy"/></Link></p>
                        <BaseButton
                            onClick={this.setCookies}
                            label={translate({id: 'cookies.popup.accept'})}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default CookiesContainer;
